import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import {
  Concentrate,
  DateRangeDefined,
  DeliveryDataItem,
  LoadDataItem,
  LoadDeliveryData,
  Milking,
  MilkPrice,
  PriceItem,
} from './dataTools.types';
import reduxConfig from '../../../store/config';
import { DataToolsType } from './dataTools.constants';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/dataTools');

export const getLoadsDeliveriesBatches = actionCreator.async<DateRangeDefined, LoadDeliveryData[]>(
  'GET_LOADS_DELIVERIES_BATCHES',
);
export const getLoadsDeliveries = actionCreator.async<string[], LoadDeliveryData[]>('GET_LOADS_DELIVERYS');
export const updateLoad = actionCreator.async<
  { batchId: string; loadId: string; data: Partial<LoadDataItem>; ignoreStock: boolean; formName: FormName },
  LoadDataItem
>('UPDATE_LOAD');
export const updateDelivery = actionCreator.async<
  { batchId: string; deliveryId: string; data: Partial<DeliveryDataItem>; ignoreStock: boolean; formName: FormName },
  DeliveryDataItem
>('UPDATE_DELIVERY');
export const deleteLoadDeliveryBatch = actionCreator.async<
  { id: string; ignoreStock: boolean; formName: FormName },
  any
>('DELETE_LOAD_DELIVERY_BATCH');
export const getIngredientPrices = actionCreator.async<string, PriceItem[]>('GET_INGREDIENT_PRICES');
export const updateIngredientPrice = actionCreator.async<
  { ingredientId: string; priceId: string; data: Partial<PriceItem>; formName: FormName },
  PriceItem
>('UPDATE_INGREDIENT_PRICE');
export const addIngredientPrice = actionCreator.async<
  { ingredientId: string; data: Partial<PriceItem>; formName: FormName },
  PriceItem
>('ADD_INGREDIENT_PRICE');

export const getMilkings = actionCreator.async<DateRangeDefined, Milking[]>('GET_MILKINGS');
export const createMilking = actionCreator.async<{ data: Partial<Milking>; formName: FormName }, Milking>(
  'CREATE_MILKING',
);
export const updateMilking = actionCreator.async<{ data: Partial<Milking>; formName: FormName }, Milking>(
  'UPDATE_MILKINGS',
);

export const getConcentrates = actionCreator.async<DateRangeDefined, Concentrate[]>('GET_CONCENTRATES');
export const createConcentrate = actionCreator.async<{ data: Partial<Concentrate>; formName: FormName }, Concentrate>(
  'CREATE_CONCENTRATE',
);
export const updateConcentrate = actionCreator.async<{ data: Partial<Concentrate>; formName: FormName }, Concentrate>(
  'UPDATE_CONCENTRATE',
);

export const getMilkPrices = actionCreator.async<{}, MilkPrice[]>('GET_MILK_PRICES');
export const createMilkPrice = actionCreator.async<
  { data: Partial<MilkPrice>; formName: FormName },
  MilkPrice | MilkPrice[]
>('CREATE_MILK_PRICE');
export const updateMilkPrice = actionCreator.async<{ data: Partial<MilkPrice>; formName: FormName }, MilkPrice>(
  'UPDATE_MILK_PRICE',
);
export const deleteMilkPrice = actionCreator.async<{ id: string; formName: FormName }, {}>('DELETE_MILK_PRICE');
export const sendLoadsData = actionCreator.async<any, {}>('SEND_LOADS_DATA');
export const clearDatatoolsData = actionCreator<DataToolsType>('CLEAR_DATATOOLS_DATA');
